// extracted by mini-css-extract-plugin
export default {"card":"Milestone_card__Iek9K"};